import { sendSumoLog } from './sumoLogger';
import { fetchTicketDocs } from './fetchTicketDocs';
import { fetchPresignedUrl } from './fetchPresignedUrl';

export const fetchFolderDocumentsFromCouchbase = async (
  id,
  token,
  dispatch,
  lastSeq = null,
  active_status = true
) => {
  try {
    let resultsArray = [];
    let lastSequence = lastSeq;
    let sinceParam = '';
    // add logging if lastSeq is undefined or null
    if (lastSequence !== null && lastSequence !== undefined) {
      sinceParam = `&since=${lastSequence}`;
      active_status = parseInt(lastSequence) <= 1;
    }

    let requestURL = encodeURI(
      `${process.env.REACT_APP_COUCHBASE_URL}/lmark/_changes?active_only=${active_status}&include_docs=false&filter=sync_gateway/bychannel&feed=normal&channels=pge_folderID-${id}${sinceParam}`
    );
    const headers = new Headers({
      Authorization: `Bearer ${token}`,
    });
    const IDresponse = await fetch(requestURL, {
      method: 'GET',
      headers,
    });

    if (!IDresponse.ok) {
      const errorType = 'fetchCBfolderID';
      const errorCode = IDresponse.status;
      const message = `Failed to fetch documents from Couchbase for folderID: ${id}`;
      sendSumoLog(errorType, message, errorCode, dispatch);
      return {
        resultsArray: [],
        lastSequence: lastSeq || 0,
      };
    }
    const IDJson = await IDresponse.json();
    const newLastSequence = IDJson.last_seq;
    const IDs = IDJson.results.filter(result => result.changes.length > 0).map(result => result.id);
    if (IDs.length > 0) {
      const splicedIDs = IDs.splice(0, 10000);
      const loggingContext = `folderID: ${id}, lastSequence: ${lastSequence}`;
      let data = await fetchTicketDocs(splicedIDs, token, dispatch, loggingContext);

      // TODO - Handle multiple channels at a time instead of sequentially fetching 10,000 at a time
      while (data.rows && data.rows.length > 0 && IDs.length > 0) {
        resultsArray = [...resultsArray, ...data.rows];
        const next10000 = IDs.splice(0, 10000);
        const loggingContext2 = `folderID: ${id}, lastSequence: ${lastSequence}`;
        data = await fetchTicketDocs(next10000, token, dispatch, loggingContext2);
      }
      if (data.rows) {
        resultsArray = [...resultsArray, ...data.rows];
      }
    }
    return {
      resultsArray: resultsArray,
      lastSequence: newLastSequence,
    };
  } catch (error) {
    const message = `Failed to fetch documents from Couchbase for folderID: ${id}`;
    sendSumoLog(error, message, dispatch);
    return {
      resultsArray: [],
      lastSequence: lastSeq || 0,
    };
  }
};

export const fetchFolderDocuments = async (
  id,
  token,
  dispatch,
  lastSeq = null,
  fetchFromS3 = false
) => {
  try {
    let resultsArray = [];
    let lastSequence = lastSeq;
    let cbDocs = [];
    // first time fetching, fetch from s3.
    if (fetchFromS3) {
      let path = `truncated/pge_folderID-${id}.json.br`;

      await fetchPresignedUrl(path, token, true)
        .then(response => fetch(response, { method: 'GET' }))
        .then(results => results.json())
        .then(async jsonResults => {
          resultsArray = jsonResults.rows;
          lastSequence = jsonResults.update_seq;
          await fetchFolderDocumentsFromCouchbase(id, token, dispatch, lastSequence, 'false').then(
            CBresults => (cbDocs = CBresults)
          );
        })
        .catch(async err => {
          await fetchFolderDocumentsFromCouchbase(id, token, dispatch, lastSequence, 'true').then(
            res => (cbDocs = res)
          );

          const location = 'File: fetchFolderDocuments.js, Function: fetchfolderDocuments';
          const errorType = 'fetchS3';
          const message = `${err.status} - Could not fetch documents from S3. Refer to: ' + ${location}`;
          const errorCode = err.status;
          sendSumoLog(errorType, message, errorCode, dispatch);
        });
      return {
        resultsArray: resultsArray,
        updatesArray: cbDocs.resultsArray,
        lastSequence: cbDocs.lastSequence,
        folderID: id,
      };
    } else {
      // if s3 fails, fall back to the changes feed code
      // on subsequent fetches, use changes feed code
      return await fetchFolderDocumentsFromCouchbase(id, token, dispatch, lastSeq, 'false');
    }
  } catch (error) {
    const message = `fetch documents for folderID: ${id} failed`;
    sendSumoLog(error, message, dispatch);
    return {
      resultsArray: [],
      lastSequence: lastSeq || 0,
    };
  }
};
